import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as d, normalizeClass as l, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMonitorOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", { d: "M4 1.5a.5.5 0 0 1 .5-.5H10a1.5 1.5 0 0 1 1.5 1.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 0 10 2H4.5a.5.5 0 0 1-.5-.5Zm-3.5 1v5A1.5 1.5 0 0 0 2 9h3.5v1H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.5V9h1.793l2.353 2.354a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.145.144A1.741 1.741 0 0 0 .5 2.5Zm1.146 5.354A.5.5 0 0 0 2 8h5.293L1.534 2.241A.92.92 0 0 0 1.5 2.5v5a.5.5 0 0 0 .146.354Z" }, null, -1), h = [
  f
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  p
];
function g(e, I, o, b, q, t) {
  return d(), n("svg", {
    "aria-label": o.ariaLabel,
    class: l([t.iconSizeClass, "d-icon d-icon--monitor-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Monitor Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, m)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", g]]);
export {
  w as default
};
//# sourceMappingURL=monitor-off.js.map
